<template>
<div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약재관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>약재코드</p>
                <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.medicineCd" @keyup.enter="fn_search" @change="fn_search_change">
              </li>
              <li>
                <p>약재명</p>
                <input type="text" placeholder="코드명을 입력하세요" class="form_control" v-model="searchInfo.medicineNm" @keyup.enter="fn_search" @change="fn_search_change">
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list mb40">
            <div class="table_option">
              <div class="page_title pb0">약재코드</div>
              <div class="form_inline">
                <input type="file" ref="medExcelUpload" @change="fn_excel_read" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden/>
                <button class="btn btn_md btn_outline" @click="fn_excel_upload_click"><i class="icon icon_excel"></i>Excel 업로드</button>
                <button class="btn btn_md btn_darkblue" v-b-modal.aroundModal @click="fn_move_reg_page">신규 등록</button>                  
              </div>
            </div>
            <table class="list">
              <thead>
                <tr>
                    <th>약재코드</th>
                    <th>약재명</th>
                    <th>설명</th>
                    <th>이명</th>
                    <th>검색유무</th>
                    <th>처리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="medicineList.length == 0">
                    <td colspan="5"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in medicineList" :key="index">
                  <td><span>{{ item.med_hrb_cd }}</span></td>
                  <td><span>{{ item.med_hrb_nm }}</span></td>
                  <td class="al"><span>{{ item.med_prfm }}</span></td>
                  <td><span>{{ item.med_alias }}</span></td> 
                  <td><span>{{ item.use_yn }}</span></td> 
                  <td>
                    <div class="form_inline">
                      <button class="icon icon_del" @click="fn_del_medHrb(item.med_hrb_cd)" ></button>
                      <button class="icon icon_edit" @click="fn_update_medHrb(item.med_hrb_cd)"></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo=searchInfo.pageInfo @clickPage="moveGrpPage" v-show="page1Show"/>
          </div>
        </section>
      </div>
    </div>    
</template>
<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import { read, utils } from 'xlsx'

    export default {
        name: 'CodeMngt',
        components: {      
            Pagination
        },
        data() {
            return {
                searchInfo : {
                    medicineCd : '',
                    medicineNm : '',
                    pageInfo : {
                      page : 1,
                      pageSize : 10,
                      totPage : 0
                    }                
                },
                searchInfoChange : false,
                medHrbCd : '',
                medHrbNm : '',
                medicineList : [],
                medHrbDtlList : [],
                page1Show : false,
                page2Show : false,
                pageInfo2 : {
                  page : 1,
                  pageSize : 5,
                  totPage : 0
                },
                medJsonData : {}          
            }
        },
        async created(){
          //검색정보 처리
          let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
          if(searchInfoStore != null && searchInfoStore != {}){
              this.searchInfo = searchInfoStore
          }
        },
        mounted(){
          this.fn_search();
        },
        methods : {
            fn_search_change(){
              //검색 정보 변경 여부
              let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];

              console.log("@@@@ searchInfoStore : %o ",searchInfoStore)
              if(searchInfoStore != null && searchInfoStore != {}){
                  if(this.searchInfo.medicineCd != searchInfoStore.medHrbCd){
                    this.searchInfoChange = true;
                  }
                  if(this.searchInfo.medHrbNm != searchInfoStore.medHrbNm){
                    this.searchInfoChange = true;
                  }
              }

            },
            fn_search(){
              // 검색정보 변경 체크
              if(this.searchInfoChange){
                //검색 조건 변경이 있을 시 페이지 정보 초기화
                this.searchInfo.pageInfo.page = 1;
              }

              axios
                  .post("/api/medicine/searchMedicine", this.searchInfo)
                  .then((res) => {
                      console.log("@@@@ res : %o",res);
                      this.medicineList = res.data.medicineInfo;

                      console.log("@@@@ medicineList : %o",this.medicineList);

                      this.searchInfo.pageInfo.totPage = res.data.totCnt;
                      
                      if(this.searchInfo.pageInfo.totPage> 0){
                        this.page1Show = true;                          
                      }   
                      
                      // 검색 정보 저장
                      this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo);
                      this.searchInfoChange = false;

                  })
                  .catch((err) => console.log(err));
                
            },
            fn_move_reg_page(){
                this.$store.dispatch('medicine/setStatus', ''); 
                this.$store.dispatch('medicine/setMedicineCd', '');
                this.$router.push("/admin/medicine/medicineMngtReg");
            },
            fn_update_medHrb(medHrbCd){
              this.$store.dispatch('medicine/setStatus', 'M'); 
              this.$store.dispatch('medicine/setMedicineCd', medHrbCd); 
              this.$router.push("/admin/medicine/medicineMngtReg");
            },
            moveGrpPage(page){
              this.searchInfo.pageInfo.page = page;
              this.fn_search();
            },
            fn_del_medHrb(medHrbCd){
                let param = new Object();
                param.medicineCd = medHrbCd;

                // 확인(확인:true, 취소:false 반환)
                if (confirm("정말 삭제하시겠습니까?")) {
                  // 확인 눌렀을 때 로직
                  axios
                    .post("/api/medicine/deleteMedicine", param)
                    .then((res) => {
                        this.fn_search();
                    })
                    .catch((err) => console.log(err));
                } else {
                  // 취소 눌렀을 때 로직
                }
            },
            fn_excel_upload_click(){
                let fileInputElement = this.$refs.medExcelUpload;
                fileInputElement.click();
            },
            fn_excel_read(event){
              console.log("@@@@@ fn_excel_read ");

              const file = event.target.files[0];
              let reader = new FileReader();
              
              reader.onload = (e) => {
                  
                  let data = reader.result;
                  
                  //type 종류: 'base64' | 'binary' | 'buffer' | 'file' | 'array' | 'string';
                  const workbook = read(data, {type: 'binary'});

                  workbook.SheetNames.forEach(sheetName => {
                    if(sheetName == "약재"){                                                             
                        workbook.Sheets[sheetName].A1.w = "med_hrb_cd";
                        workbook.Sheets[sheetName].B1.w = "med_hrb_nm";
                        workbook.Sheets[sheetName].C1.w = "med_prfm";
                        workbook.Sheets[sheetName].D1.w = "med_alias";
                       
                       
                       const roa = utils.sheet_to_json(workbook.Sheets[sheetName]);                       
                       
                       this.fn_excel_med_upload(roa);                     
                    }
                  });                                             
              };
              
              reader.readAsBinaryString(file);
              event.target.files[0] = null;
            },
            fn_excel_med_upload(uploadData){
              axios
                .post("/api/medicine/excelMedUpload", uploadData)
                .then((res) => {
                    // alert("삭제되었습니다");
                    // this.fn_dtl_search(medHrbCd);
                })
                .catch((err) => console.log(err));

            }
        },
        
    }
</script>